import type { ReportType } from '@common/types'
import { REPORT_TYPE_LABELS } from '@common/types'
import { cn } from '@frontend/lib/utils'

function getReportTypeClasses(reportType: string): string {
  if (reportType.startsWith('soc2')) {
    return 'bg-violet-50 text-violet-700 border-violet-200'
  } else if (reportType === 'soc3') {
    return 'bg-purple-50 text-purple-700 border-purple-200'
  } else if (reportType.startsWith('iso')) {
    return 'bg-sky-50 text-sky-700 border-sky-200'
  }
  return 'bg-slate-100 text-slate-600 border-slate-200'
}

interface ReportTypeBadgeProps {
  reportType: string | null
  className?: string
}

export function ReportTypeBadge({ reportType, className }: ReportTypeBadgeProps) {
  if (!reportType) {
    return <span className="text-muted-foreground">—</span>
  }

  const label = REPORT_TYPE_LABELS[reportType as ReportType] || reportType

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium',
        getReportTypeClasses(reportType),
        className
      )}
    >
      {label}
    </span>
  )
}
